import { useState, useRef, useEffect } from 'react';
import getXcolumnJson from "./xcolumn/list";
import my_axios, { get_axios_data } from "@/pcomponents/common/axios";
import Paging from "@/pcomponents/common/crud/list/paging/paging";
import LayerPopup from '@/pcomponents/common/popup/layer/layer_popup';
import ViewStuLayerPopup from "@/pages/comp/basic/student/popup/view_layer";
import RequestOrderPopup from "@/pages/comp/book_order/shop/order/popup/request_order";
import PayByDetPopup from "@/pages/comp/book_order/book_order_use/popup/pay_by_det";
import FindSimpleTextBookPopup from "@/pages/comp/book_order/textbook/popup/find_simple";
import UseOrderDetPopup from "@/pages/comp/book_order/book_order_use/popup/use_order_det";
import SearchArea from "@/pages/comp/basic/student/list/area/search/search_area";
import strFunc from '@/lib/lyg/string';
import { useSelector, useDispatch } from 'react-redux';
import DateFunc from '@/lib/lyg/date_func';
import { useReactToPrint } from 'react-to-print';
import StuListExcelDown from "@/pages/comp/basic/student/list/area/excel_down";
import { useNavigate } from "react-router";
import ManageBtnArea from "./area/manage_btns";
import ListArea from "./area/list";

function ListPage() {
  let user = useSelector((state: any) => state.user);
  const navigate = useNavigate();
  const xColumnArr = getXcolumnJson();
  const StuListExcelDownRef = useRef<any>(null);
  let origin_order_id = "a_stu_grade, a_user_name";

  let now_date_str = DateFunc.get_date_format(new Date(), "Y-m-d");
  const [listOpt, setListOpt] = useState({
    ...xColumnArr.list_opt,
    order_id: origin_order_id,
    s_stu_state: "now",
    s_grade: ["student"],
    // s_addon_data:"1",
    s_stu_lecture_seq: "",//user.user_grade == "master" ? "" : strFunc.get_storage_array("s_stu_lecture_seq", "", ",")
    s_addon_class_user: "1",
    s_addon_comp_link: "1",
    s_addon_textbook_use: "1",
    s_addon_textbook_use_addon_book: "1",
    s_addon_daily_report_last: "1",
  });
  const listOpt_ref = useRef<any>(listOpt);
  listOpt_ref.current = listOpt;

  const [infoArr, setInfoArr] = useState([]);
  const [countInfo, setCountInfo] = useState({ "tot": 0 });
  const [select_seq_arr, set_select_seq_arr] = useState<any>([]);
  const [select_use_seq_arr, set_select_use_seq_arr] = useState<any>([]);
  const [order_det_arr, set_order_det_arr] = useState<any>([]);
  const [select_order_det_seq_arr, set_select_order_det_seq_arr] = useState<any>([]);
  const [is_show_master, set_is_show_master] = useState(false);
  const [mcomp_point, set_mcomp_point] = useState<any>(0);

  const list_table_wrap_ref = useRef<HTMLDivElement>(null);
  const handlePrint = useReactToPrint({
    content: () => list_table_wrap_ref.current,
  });

  const [popupData, setPopupData] = useState<any>({
    isOpen: false,
    sort: "write",//use_order_det
    has_header: true,
    write_page_data: {
      is_show: false,
      is_update: false,
      is_view_mode: true,
      is_view_basic: true,
      info_arr: [],
      select_idx: 0,
      default_write_info: {},
    },
    stu_seq_arr: [],
    mcomp_seq: "",
    select_order_det_arr: [],
    stu_info: {},
    order_det_seq_arr: [],
    title: "팝업",
    width: "800px",
    height: "85%",
  });

  useEffect(() => {
    list({});
    getPointNumByAjax();
  }, [user]);

  const list = (inOptObj: any) => {
    let tmp_list_opt = {
      ...listOpt,
      ...inOptObj
    };
    setListOpt(tmp_list_opt);

    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/basic/user/user/list',
      tmp_list_opt, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          setInfoArr(response.data["data"]["info_arr"]);
          setCountInfo(response.data["data"]["count_info"]);
          let tmp_user_seq_arr: any = [];
          for (let i = 0; i < response.data["data"]["info_arr"].length; i++) {
            let info = response.data["data"]["info_arr"][i];
            if (!strFunc.is_empty(info["a_seq"])) {
              tmp_user_seq_arr.push(info["a_seq"]);
            }
          }
          get_order_arr_by_ajax({ user_seq_arr: tmp_user_seq_arr });
        } else {

        }
      });
  };

  const get_order_arr_by_ajax = (inData: any) => {
    let opt_obj = {
      user_seq_arr: [],
      ...inData
    };

    if (opt_obj.user_seq_arr.length == 0) {
      set_order_det_arr([]);
      return false;
    }

    if (strFunc.is_empty(user.comp_seq)) {
      set_order_det_arr([]);
      return false;
    }

    let form_json_data: any = {
      s_buy_mcomp_seq: user.comp_seq,
      s_buy_user_seq: opt_obj.user_seq_arr,
      order_id: "a_ymd DESC,a_seq DESC",
      s_addon_mcomp: "",
      s_addon_order: "1",
      s_addon_order_s_payt: "1",
      is_paging: "",
    };

    my_axios.post(process.env.REACT_APP_API_URL + '/api/main/shop/shop_order_det/list',
      form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          set_order_det_arr(response.data["data"]["info_arr"]);
        } else {

        }
      });
  };

  const getPointNumByAjax = () => {
    if (strFunc.is_empty(user.comp_seq)) {
      return false;
    }
    let point_form_json = {
      "s_seq": [user.comp_seq],
      "is_addon_point_tot": "1",
      "is_paging": "",
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/main/mcomp/mcomp/list', point_form_json, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          if (response.data["data"]["info_arr"].length > 0) {
            let corp_info = response.data["data"]["info_arr"][0];
            if (corp_info.point_tot_info) {
              set_mcomp_point(corp_info.point_tot_info.tot);
            }
          }
        } else {

        }
      });
  };

  const get_select_info_arr = (inData: any) => {
    let opt_obj = {
      select_seq_arr: select_seq_arr,
      ...inData
    };
    let select_info_arr: any = [];
    for (let i = 0; i < infoArr.length; i++) {
      let info = infoArr[i];
      if (strFunc.str_in_array(info["a_seq"], opt_obj.select_seq_arr) != -1) {
        select_info_arr.push(info);
      }
    }
    return select_info_arr;
  };

  const select_show_write_page = (inData: any) => {
    let opt_obj = {
      selected_row: get_select_info_arr({}),
      ...inData
    };
    let selected_row = opt_obj.selected_row;
    if (selected_row.length == 0) {
      alert("선택이 필요합니다.");
      return false;
    } else if (selected_row.length != 1) {
      alert("1명만 선택해주세요.");
      return false;
    }
    let stu_seq = selected_row[0]["a_seq"];
    if (strFunc.is_empty(stu_seq)) {
      alert("학생키 없음.");
      return false;
    }
    show_write_page(true, selected_row[0]);
  };

  const delete_order_by_ajax = (inData: any) => {
    let opt_obj = {
      order_pri_val_arr: [],
      ...inData
    };
    if (opt_obj.order_pri_val_arr.length == 0) {
      alert("선택된 주문내역이 없습니다.");
      return false;
    }

    if (!confirm("선택된 주문내역을 삭제하시겠습니까?")) {
      return false;
    }

    let selected_rows: any = [];
    for (let i = 0; i < opt_obj.order_pri_val_arr.length; i++) {
      let row_pri_val = opt_obj.order_pri_val_arr[i];
      let row_pri_val_arr = row_pri_val.split(",");
      if (row_pri_val_arr.length != 2) {
        continue;
      }
      selected_rows.push({
        a_ymd: row_pri_val_arr[0],
        a_seq: row_pri_val_arr[1],
      });
    }

    let del_form_data = {
      "data_arr": selected_rows
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/main/shop/shop_order/delete', del_form_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          list({});
        } else {
          alert(response.data["msg"]);
        }
      });
  };

  const delete_textbook_use_by_ajax = (inData: any) => {
    let opt_obj = {
      textbook_use_arr: [],
      ...inData
    };
    if (opt_obj.textbook_use_arr.length == 0) {
      alert("선택된 교재사용내역이 없습니다.");
      return false;
    }

    if (!confirm("선택된 교재사용내역을 삭제하시겠습니까?")) {
      return false;
    }

    let del_form_data = {
      "data_arr": opt_obj.textbook_use_arr,
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/main/textbook/use/delete', del_form_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          list({});
        } else {
          alert(response.data["msg"]);
        }
      });
  };

  const send_payt_cancel_by_ajax = (inData: any) => {
    let opt_obj = {
      selected_row: [],
      change_state: "destroy",//cancel,destroy
      ...inData
    };
    let selected_row = opt_obj.selected_row;
    if (selected_row.length === 0) {
      alert("선택없음.");
      return false;
    }
    let confrim_msg = "청구서를 취소하시겠습니까?(결제선생)";
    if (opt_obj["change_state"] == "destroy") {
      confrim_msg = "청구서를 파기하시겠습니까?(결제선생)";
    }
    if (confirm(confrim_msg) == false) {
      return false;
    }

    let order_seq_arr: any = [];
    for (let i = 0; i < selected_row.length; i++) {
      let tmp_row = selected_row[i];
      let row_pri_val = tmp_row["row_pri_val"];
      order_seq_arr.push(row_pri_val);
    }

    let form_data = {
      "order_seq_arr": order_seq_arr,
      change_state: opt_obj["change_state"],
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/main/shop/shop_order/send_payt_cancel', form_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          alert(response.data["msg"]);
          list({});
        } else {
          alert(response.data["msg"]);
        }
      });
  };

  const send_payt_send_read_by_ajax = (inData: any) => {
    let opt_obj = {
      order_info_arr: [],
      ...inData
    };
    let order_info_arr = opt_obj.order_info_arr;
    if (order_info_arr.length === 0) {
      alert("선택없음.");
      return false;
    }

    if (confirm("청구서를 확인하시겠습니까?(결제선생)") == false) {
      return false;
    }

    let order_seq_arr: any = [];
    for (let i = 0; i < order_info_arr.length; i++) {
      let tmp_row = order_info_arr[i];
      let row_pri_val = tmp_row["row_pri_val"];
      order_seq_arr.push(row_pri_val);
    }

    let form_data = {
      "order_seq_arr": order_seq_arr,
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/main/shop/shop_order/send_payt_read', form_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          alert(response.data["msg"]);
          list({});
        } else {
          alert(response.data["msg"]);
        }
      });
  };

  const show_write_page = (is_update: boolean, info: any) => {
    let select_idx = -1;
    let all_rows = infoArr;
    if (is_update) {
      for (let i = 0; i < all_rows.length; i++) {
        if (all_rows[i]["a_seq"] == info["a_seq"]) {
          select_idx = i;
        }
      }
    }
    if (is_update) {
      if (select_idx == -1) {
        alert("선택이 잘못되었습니다.");
        return false;
      }
    }
    let write_page_data = {
      is_show: true,
      is_update: is_update,
      is_view_mode: is_update,
      is_view_basic: true,
      select_idx: select_idx,
      info_arr: all_rows,
      default_write_info: { ...info },
    };

    let comp_sort_detail = user.comp_sort_detail;
    if (comp_sort_detail == "plani") {
      navigate("/comp/basic/student/list_view", {
        state: {
          write_page_data: write_page_data
        }
      });
    } else {
      setPopupData({
        ...popupData,
        "isOpen": true,
        "title": "원생관리",
        "sort": "stu_view",
        write_page_data: write_page_data,
        width: "99%",
        height: "99%",
        has_header: false,
      });
    }
  };

  const open_request_order_popup = (inData: any) => {
    let opt_obj = {
      mcomp_seq: user.comp_seq,
      stu_seq_arr: select_seq_arr,
      ...inData
    };
    if (strFunc.is_empty(opt_obj.stu_seq_arr)) {
      alert("학생키가 없습니다.");
      return false;
    }
    setPopupData({
      ...popupData,
      "isOpen": true,
      "title": "주문하기",
      "sort": "request_order",
      stu_seq_arr: opt_obj.stu_seq_arr,
      mcomp_seq: opt_obj.mcomp_seq,
      width: "80%",
      height: "80%",
      has_header: true,
    });
  };

  const callback_open_request_order_popup = (inData: any) => {
    let opt_obj = {
      info_arr: [],
      ...inData
    };
  };

  const open_pay_by_det_popup = (inData: any) => {
    let opt_obj = {
      select_order_det_arr: order_det_arr,
      ...inData
    };

    if (opt_obj.select_order_det_arr.length == 0) {
      alert("선택된 주문내역이 없습니다.");
      return false;
    }

    setPopupData({
      ...popupData,
      "isOpen": true,
      "title": "결제하기",
      "sort": "pay_by_det",
      select_order_det_arr: opt_obj.select_order_det_arr,
      width: "500px",
      height: "90%",
      has_header: true,
    });
  };

  const callback_pay_by_det_popup = (inData: any) => {

  };

  const open_find_textbook_each_order_popup = (inData: any) => {
    let opt_obj = {
      stu_info: {},
      ...inData
    };

    if (strFunc.is_empty(opt_obj.stu_info["a_seq"])) {
      alert("학생키가 없습니다.");
      return false;
    }

    let pop_w = "70%";
    let win_w = (window.innerWidth || document.documentElement.clientWidth);
    if (win_w < 700) {
      pop_w = "99%";
    }

    setPopupData({
      ...popupData,
      "isOpen": true,
      "title": "교재 찾기",
      "sort": "find_textbook_each_order",
      stu_info: opt_obj.stu_info,
      width: pop_w,
      height: "70%",
      has_header: true,
    });
  };


  const callback_find_textbook_each_order = (inData: any) => {
    let opt_obj = {
      info_arr: [],
      is_order_online: false,
      ...inData
    };

    if (opt_obj.info_arr.length == 0) {
      return false;
    }
    if (strFunc.is_empty(user.comp_seq)) {
      return false;
    }
    if (strFunc.is_empty(user.user_seq)) {
      return false;
    }
    if (popupData.stu_info == undefined || strFunc.is_empty(popupData.stu_info["a_seq"])) {
      alert("학생정보가 없습니다.");
      return false;
    }

    if (!confirm("교재를 선택 하시겠습니까?")) {
      return false;
    }

    let order_book_seq_arr: any = [];
    for (let i = 0; i < opt_obj.info_arr.length; i++) {
      order_book_seq_arr.push(opt_obj.info_arr[i].a_seq);
    }

    let form_json_data: any = {
      "mcomp_seq": user.comp_seq,
      "stu_seq_arr": [popupData.stu_info["a_seq"]],
      "book_seq_arr": order_book_seq_arr,
      "reg_user_seq": user.user_seq,
      "product_type": opt_obj.is_order_online ? "mtextbook_period" : "mtextbook",
      is_order_online: opt_obj.is_order_online ? "1" : "0",
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/main/shop/shop_order/add_order_by_book',
      form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          list({});
          alert("교재를 선택하였습니다.");
        } else {
          alert("교재 선택에 실패하였습니다." + response.data["msg"]);
        }
      });
  };

  const go_add_order_period_by_ajax = (inData: any) => {
    let opt_obj = {
      stu_seq: "",
      order_book_seq_arr: [],
      use_sort: "",//word_inside
      ...inData
    };

    let order_book_seq_arr = opt_obj.order_book_seq_arr;
    if (order_book_seq_arr.length == 0) {
      alert("선택된 교재가 없습니다.");
      return false;
    }
    if (strFunc.is_empty(opt_obj.stu_seq)) {
      alert("학생키가 없습니다.");
      return false;
    }
    if (strFunc.is_empty(user.comp_seq)) {
      return false;
    }
    if (strFunc.is_empty(user.user_seq)) {
      return false;
    }
    let period_day_num = 14;
    if (opt_obj.use_sort == "word_inside") {
      period_day_num = 30;
    }
    if (!confirm("해당 교재의 온라인 학습을 " + period_day_num + "일 연장 신청 하시겠습니까?")) {
      return false;
    }

    let form_json_data: any = {
      "mcomp_seq": user.comp_seq,
      "stu_seq_arr": [opt_obj.stu_seq],
      "book_seq_arr": order_book_seq_arr,
      "reg_user_seq": user.user_seq,
      "product_type": "mtextbook_period",
      "is_order_online": "1",
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/main/shop/shop_order/add_order_by_book',
      form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          list({});
          //alert("주문이 완료되었습니다.");
        } else {
          alert("주문에 실패하였습니다." + response.data["msg"]);
        }
      });
  };

  const go_use_of_order_det_by_ajax = (inData: any) => {
    let opt_obj = {
      order_det_arr: [],
      ...inData
    };

    if (opt_obj.order_det_arr.length == 0) {
      alert("선택된 주문내역이 없습니다.");
      return false;
    }

    let order_det_seq_arr: any = [];
    for (let i = 0; i < opt_obj.order_det_arr.length; i++) {
      let order_det = opt_obj.order_det_arr[i];

      if (!strFunc.is_empty(order_det["row_pri_val"])) {
        order_det_seq_arr.push(order_det["row_pri_val"]);
      }
    }

    setPopupData({
      ...popupData,
      isOpen: true,
      sort: "use_order_det",
      title: "교재사용승인",
      order_det_seq_arr: order_det_seq_arr,
      width: "800px",
      height: "85%",
    });

    return false;

    if (confirm("선택된 교재를 승인 하시겠습니까?") == false) {
      return false;
    }

    let form_json_data: any = {
      "mcomp_seq": user.comp_seq,
      "order_det_seq_arr": order_det_seq_arr,
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/main/shop/shop_order_det/use_of_order_det',
      form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          list({});
          alert("승인처리가 완료되었습니다.");
        } else {
          alert("승인처리에 실패하였습니다." + response.data["msg"]);
        }
      });
  };

  return (
    <div>
      <SearchArea
        listOpt={listOpt}
        setListOpt={setListOpt}
        xColumnArr={xColumnArr}
        list={list}
        is_show_add_btn={false}
        sub_right_text={
          <span>
            (총 <span style={{ color: "#2e5251" }}>{countInfo.tot}</span> 명)
          </span>
        }
      ></SearchArea>
      <ManageBtnArea
        order_det_arr={order_det_arr}
        select_order_det_seq_arr={select_order_det_seq_arr}
        set_select_order_det_seq_arr={set_select_order_det_seq_arr}
        open_request_order_popup={open_request_order_popup}
        open_pay_by_det_popup={open_pay_by_det_popup}
        mcomp_point={mcomp_point}
      ></ManageBtnArea>
      <div className="list_round_box mt-2">
        <div ref={list_table_wrap_ref}>
          <style type="text/css" media="print">
            {true ? " @page { size: landscape; }@media print {html,body {width: 290mm;max-height:201mm; }} " : ""}
          </style>
          <ListArea
            xColumnArr={xColumnArr}
            infoArr={infoArr}
            setInfoArr={setInfoArr}
            select_seq_arr={select_seq_arr}
            set_select_seq_arr={set_select_seq_arr}
            select_use_seq_arr={select_use_seq_arr}
            set_select_use_seq_arr={set_select_use_seq_arr}
            select_show_write_page={select_show_write_page}
            order_det_arr={order_det_arr}
            select_order_det_seq_arr={select_order_det_seq_arr}
            set_select_order_det_seq_arr={set_select_order_det_seq_arr}
            delete_order_by_ajax={delete_order_by_ajax}
            delete_textbook_use_by_ajax={delete_textbook_use_by_ajax}
            go_use_of_order_det_by_ajax={go_use_of_order_det_by_ajax}
            go_add_order_period_by_ajax={go_add_order_period_by_ajax}
            send_payt_cancel_by_ajax={send_payt_cancel_by_ajax}
            send_payt_send_read_by_ajax={send_payt_send_read_by_ajax}
            open_request_order_popup={open_request_order_popup}
            open_find_textbook_each_order_popup={open_find_textbook_each_order_popup}
          ></ListArea>
        </div>
        <Paging now_page={listOpt.now_page}
          num_per_page={listOpt.num_per_page}
          total_rec={countInfo.tot}
          onChangePage={(now_page: number) => { list({ now_page: now_page }); }}
          is_view_num_per_page={true}
          is_show_total_rec={true}
          onChangeNumPerPage={(num_per_page: number) => { list({ now_page: 1, num_per_page: num_per_page }); }}></Paging>
      </div>
      {user.user_seq == "9999" &&
        <div className='text-right'>
          <button className='btn btn-dark'
            onClick={() => {
              if (is_show_master) {
                list({
                  s_stu_state: "now",
                  s_grade: ["student"],
                  now_page: 1,
                });
              } else {
                list({
                  s_stu_state: "",
                  s_grade: ["master", "teacher"],
                  now_page: 1,
                });
              }
              set_is_show_master(!is_show_master);
            }}  >
            {is_show_master ? "학생" : "매니저"}
          </button>
        </div>
      }
      <StuListExcelDown
        ref={StuListExcelDownRef}
        infoArr={infoArr}
      ></StuListExcelDown>

      {popupData.isOpen &&
        <LayerPopup closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }} title={popupData.title}
          width={popupData.width} height={popupData.height} has_header={popupData.has_header} >
          {popupData.sort === "stu_view" &&
            <ViewStuLayerPopup
              write_page_data={popupData.write_page_data}
              callback={() => { list({}); }}
              closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }}
            ></ViewStuLayerPopup>
          }
          {popupData.sort === "request_order" &&
            <RequestOrderPopup
              mcomp_seq={popupData.mcomp_seq}
              stu_seq_arr={popupData.stu_seq_arr}
              refreshData={() => { list({}); }}
              callbackData={callback_open_request_order_popup}
              closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }}
            ></RequestOrderPopup>
          }
          {popupData.sort === "pay_by_det" &&
            <PayByDetPopup
              select_order_det_arr={popupData.select_order_det_arr}
              refreshData={() => { list({}); }}
              callbackData={callback_pay_by_det_popup}
              closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }}
            ></PayByDetPopup>
          }
          {popupData.sort === "find_textbook_each_order" &&
            <FindSimpleTextBookPopup
              listOpt={{ s_is_able_order: "1", s_subject: user.main_subject }}
              refreshData={() => { list({}); }}
              xcolumn_unshow_key_arr={["row_view_stock_cnt"]}
              callbackData={callback_find_textbook_each_order}
              closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }}
            ></FindSimpleTextBookPopup>
          }
          {popupData.sort === "use_order_det" &&
            <UseOrderDetPopup
              order_det_seq_arr={popupData.order_det_seq_arr}
              closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }}
              refreshData={() => { list({}); }}
            ></UseOrderDetPopup>
          }
        </LayerPopup>
      }
    </div>
  );
}

export default ListPage;